import ScrollReveal from "../../../components/feature/ScrollReveal";
import { introData } from "../../../mocks/yokohamaData";

export default function IntroSection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-16">
              <p className="section-label mb-3">{introData.label}</p>
              <h2 className="section-title">{introData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            <ScrollReveal direction="up" delay={150}>
              <div className="flex flex-col gap-5">
                {introData.paragraphs.map((p, idx) => (
                  <p
                    key={idx}
                    className="text-sm md:text-base text-airdoa-gray leading-[2]"
                  >
                    {p}
                  </p>
                ))}
              </div>
            </ScrollReveal>

            <div className="flex flex-col gap-6">
              <ScrollReveal direction="up" delay={250}>
                <div className="overflow-hidden rounded-lg">
                  <img
                    src={introData.image}
                    alt="ヘリコプター機内からの景色"
                    className="w-full h-64 md:h-72 object-cover object-top"
                  />
                </div>
              </ScrollReveal>

              <ScrollReveal direction="up" delay={350}>
                <div className="grid grid-cols-3 gap-3">
                  {introData.stats.map((stat) => (
                    <div
                      key={stat.label}
                      className="text-center p-4 bg-airdoa-cream rounded-lg"
                    >
                      <p className="text-lg md:text-xl font-serif font-semibold text-airdoa-navy">
                        {stat.value}
                      </p>
                      <p className="text-xs text-airdoa-gray mt-1">
                        {stat.label}
                      </p>
                    </div>
                  ))}
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
